import { render, staticRenderFns } from "./Standards.vue?vue&type=template&id=b31998b6"
import script from "./Standards.vue?vue&type=script&lang=js"
export * from "./Standards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbarTitle})
